<template>
  <div>
    <h3 class="header-title">Payment</h3>
    <label>Let’s see your tuition student generate payment.</label>
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your payment student !</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <template>
      <CCard class="mt-4">
        <CRow class="mt-4">
          <CCol sm="1"></CCol>
          <CCol sm="3">
            <v-select
              horizontal
              v-model="SelectedMonth"
              :options="dataList"
              placeholder="Select Month"
            />
          </CCol>
          <!-- <CCol sm="3">
            <input name="text" class="form-control" value="-">
          </CCol>
          <CCol sm="3">
            <CButton class="custom-btn-light" size="sm" @click="RefreshData()">
              <div>
                <CIcon name="cilSync" />
              </div>
            </CButton>
          </CCol> -->
          <CCol sm="1"></CCol>
        </CRow>
        <br />
        <!-- <CRow>
          <CCol sm="1"></CCol>
          <CCol sm="10">
            <CInput type="text" placeholder="Search"></CInput>
          </CCol>
          <CCol sm="1"></CCol>
        </CRow> -->
        <hr />
        <CRow>
          <CCol sm="1" class="mt-1"></CCol>
          <CCol sm="10" class="mt-1">
            <h5>
              <strong> Generate Invoice</strong>
            </h5>
          </CCol>
          <CCol sm="1" class="mt-1"></CCol>
        </CRow>
        <CRow>
          <CCol sm="1" class="mt-1"></CCol>
          <CCol sm="3" class="mt-1">
            <h5>Initial Invoice No.(e.g 1 or leave it blank for default)</h5>
          </CCol>
          <CCol sm="5">
            <CInput type="text" v-model="InvoiceNo"></CInput>
          </CCol>
          <CCol sm="3">
            <CButton
              type="button"
              color="success"
              @click="GetTuitionPaymentStudent()"
            >
            {{ labelMessage }}
             
            </CButton>
          </CCol>
        </CRow>
      </CCard>
      <CCard
        class="p-4"
        style="background-color: #ffe6de; border-color: #fb3a3a"
      >
        Note : This process to allow learning center to create invoices
        with their own defined number. Only number (0..9) and no characters are
        allowed. If "Initial Invoice No." inserted,all invoices will be
        generated in sequence number (e.g 100.. 101,102,103..). Leave it blank
        for auto generate by system.
      </CCard>
      <CRow v-if="Busy == true">
        <CCol sm="12" md="12">
          <div class="app flex-row align-items-center">
            <div class="container d-flex justify-content-center">
              <PulseLoader float />
            </div>
          </div>
        </CCol>
      </CRow>
      <div v-else>
        <CButton color="success" size="md" class="m-1" @click="InsertPayment"
          >{{ labelBtn }}</CButton
        >
        <CAlert color="danger" v-if="ErrorMessage ==true">Error to generate invoice</CAlert>
        <CAlert color="success" v-if="successMessage ==true">Successfully generate invoice</CAlert>

        <CInput
              type="text"
              placeholder="Search...."
              v-model.lazy="SearchQuery"
              class="p-2"
            />
        <table
          class="table table-responsive-sm table-hover table-outline mb-0 mt-2"
        >
          <thead>
            <th>
              <input type="checkbox" @click="checkAll()" v-model="isCheckAll" />
            </th>
            <th>No</th>
            <th>Student Name</th>
            <th>Payment Fee</th>
            <th>Discount</th>
            <th>Month</th>
            <th>Tuition Invoice No.</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in FilteredGenerateList" v-bind:key="item.id">
              <td>
                <input
                  type="checkbox"
                  id="checkbox"
                  v-model="item.isChecked"
                  @change="addAmountPayment(item)"
                />
              </td>
              <td>{{ index + 1 }}</td>
              <td>
                {{ item.studentName }}

                <br />
                Parent : {{ item.parentName }}
                <br />
                Phone : {{ item.parentPhone }}
                <br />
                Email : {{ item.parentEmail }}
              </td>
              <td>{{ item.paymentFee }}</td>
              <td>{{ item.discount }}</td>
              <td>{{ item.note }}</td>
              <td>{{ item.tuitionInvoiceNum }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <br />
    </template>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import moment from "moment";


import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import $ from "jquery";

Vue.use(VuejsDialog);


import VuePapaParse from "vue-papa-parse";
Vue.use(VuePapaParse);

export default {
  name: "Overview",
  components: {
    PulseLoader,
    moment,
    cSwitch,
    VueCal,
  },
  props: ["manualstudentid", "invoiceid", "note"],
  data: function () {
    return {
      users: ["Students", "Teachers", "Parents"],
      collapse: false,
      attendance: false,
      quizs: false,
      subject: false,
      payment: false,
      schedule: false,
      parent: false,
      ViewSetPaymentModal: false,
      ViewAddPaymentModal: false,
      ViewPrintPaymentModal: false,
      ViewDeletePaymentModal: false,
      SelectedMonth: "",
      SelectedParent: "",
      parents: [],
      SelectedStudent: "",
      students: [],
      studentDetails: {},
      feedData: [],
      tuitionPayments: [],
      isCheckAll: false,
      Busy: false,

      eventCategories: [
        {
          id: 1,
          title: "Schedule",
          textColor: "white",
          backgroundColor: "red",
        },
      ],

      dataList: [],

      fields: [
        { key: "No" },
        { key: "studentName" },
        { key: "paymentFee" },
        { key: "discount" },
        { key: "month" },
        { key: "tuitionInvoiceNum" },
        { key: "Action" },
      ],
      InvoiceNo: "1",
      successMessage: false,
      ErrorMessage: false,

      SearchQuery: "",
      FilteredGenerate: [],

      labelBtn: 'Generate Payment',
      labelMessage: 'View Output',
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetAllParentsList();
      this.GetAllStudentsList();
      this.GetStudentDetails();
      const currentDate = new Date();
const startYear = currentDate.getFullYear() - 2;
const endYear = currentDate.getFullYear();
const startMonth = currentDate.getMonth() + 1; // add 1 because getMonth() returns 0-indexed values
const endMonth = startMonth + 6; // add 6 to include the next six months
const months = [];

for (let year = startYear; year <= endYear; year++) {
  const monthLimit = year === endYear ? endMonth : 12;

  for (let month = 1; month <= monthLimit; month++) {
    const date = new Date(`${year}/${month}/01`); // use YYYY/MM/DD format for date
    const monthName = date.toLocaleString("default", { month: "long" });
    months.push({
      label: `${monthName} ${year}`,
      value: `${year}-${month.toString().padStart(2, "0")}`, // format as YYYY-MM
    });
  }
}

this.dataList = months;
      console.log("month" + this.dataList);
    } else {
      this.GoToLogin();
    }
  },
  computed: {
    FilteredGenerateList() {
      if(this.SearchQuery === '') return this.FilteredGenerate
      return this.FilteredGenerate.filter(item => {   
        //subject name
        if (
            item.studentName.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1 
          ) {
            return item
          }
          if (
            item.note.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1 
          ) {
            return item
          }
          if (
            item.discount.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1 
          ) {
            return item
          }
          if (
            item.parentName.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1 
          ) {
            return item
          }
          if (
            item.parentPhone.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1 
          ) {
            return item
          }
          if (
            item.parentEmail.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1 
          ) {
            return item
          }



      })

  },
  },
  methods: {
    async RefreshData() {
      //this.PaginationLoading = true;
      //this.CurrentPage = 1;
      //this.LastUserPerPageArray = {};
      await this.GetStudentDetails();
      await this.GetTuitionPaymentStudent();
      //this.PaginationLoading = false;
    },
    async GetAllParentsList() {
      this.$API
        .get(this.$AllParentList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.parents = response.data;
          }
        });
    },
    async GetAllStudentsList() {
      this.$API
        .get(this.$AllStudentList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
          }
        });
    },
    async GetStudentDetails() {
      this.$API
        .get(
          this.$StudentDetailByIdAuthorize + "?id=" + this.SelectedStudent.Id,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });
    },
    async GetTuitionPaymentStudent() {
      this.labelMessage = 'Processing';
      this.Busy = true;
      this.$API
        .get(
          this.$GetTuitionPaymentStudent +
            "?month=" +
            this.SelectedMonth.label +
            "&invoicevalue=" +
            this.InvoiceNo,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.labelMessage = 'View Output';
            this.Busy = false;
            this.tuitionPayments = response.data;
            this.FilteredGenerate = this.tuitionPayments;
          }
          else
          {
            this.Busy = false;
          }
        });
    },
    removeRow: function (index) {
      this.tuitionPayments.splice(index, 1);
    },
    addAmount(data) {
      if (data.isChecked) {
      } else {
      }
    },
    checkReset() {
      if (this.isCheckAll == true) {
        this.isCheckAll = false;
      }
      var temp = this;
      console.log("1");
      this.tuitionPayments.forEach(function (item) {
        if (item.isChecked == true) {
          console.log("2");

          item.isChecked = false;

          console.log("5");
        }
      });
    },
    checkAll: function () {
      this.isCheckAll = !this.isCheckAll;
      var temp = this;
      this.tuitionPayments.forEach(function (item) {
        if (item.isChecked !== temp.isCheckAll) {
          item.isChecked = temp.isCheckAll;
        }
      });
    },
    deleteSelected(item) {
      var items = item.isChecked;
      this.tuitionPayments = this.tuitionPayments.filter(
        (item) => !items.includes(item.No)
      );
      items = [];
    },
    // deleteSelected() {

    //   if (confirm("Are you sure you want to delete this item?")) {
    //     for (var i = 0; i < this.selected.length; i++) {
    //       const index = this.tuitionPayments.indexOf(this.selected[i]);
    //       this.tuitionPayments.splice(index, 1);
    //     }
    //   }
    // },
    GotoAttendancePage(item) {
      let arr = this.studentDetails;
      let routeData = this.$router.resolve({
        //this.$router.push({
        path: "/TuitionAttendanceStudent",
        params: {
          manualstudentid: arr.Id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    async GetPaymentStudentById() {
      this.$API
        .get(this.$AllParentList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.parents = response.data;
          }
        });
    },
    goToday() {
      this.$refs.calendar.goToday();
    },
    InsertPayment() {
      this.labelBtn = 'Processing';
      const formData = new FormData();
      var combinedSubject = []; // Move this outside the for loop

      for (var index = 0; index < this.tuitionPayments.length; index++) {
        let item = this.tuitionPayments[index];
        if (item.isChecked) {
          let combinedItem = {
      ManualStudentId: item.studentId,
      PaymentFee: item.paymentFee,
      InvoiceId: item.tuitionInvoiceNum,
      TuitionInvoiceId: item.tuitionInvoiceNum,
      Note: item.note,
      Discount: item.discount !== '' ? item.discount : "0"
    };
    combinedSubject.push(combinedItem);
        }
      }
      // Append the combined subject data to the formData only once
      let subjectData = JSON.stringify(combinedSubject);
      formData.append("generateJson", subjectData);
      formData.append("invoiceNum", this.InvoiceNo);

      return this.$API
        .post(this.$InsertGenerateInvoice, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.labelBtn = 'Generate Payment';
            this.successMessage = true;
            this.$dialog
              .alert("You have successfully generate invoice")
              .then(function () {});
            this.RefreshData();
            this.isCheckAll = false;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.ErrorMessage = true;
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
  },
};
</script>
<style>
.custom-text-overview {
  color: #000000 !important;
}
.custom-small-overview {
  font-size: 90%;
  font-weight: 500;
}
.custom-small {
  font-size: 90%;
  font-weight: 500;
}
</style>